module.exports = __webpack_public_path__ + "./Jasmine_e8f912691a95d6191eee300ec051a05d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jasmine.jpg
// module id = 558
// module chunks = 0